import { DynamicConditionalActionChainArgs, StepValue } from '../types';

import { SelectNextByActionStepBuilder } from './select-next-by-action-step-builder';
import { SelectNextByValueStepBuilder } from './select-next-by-value-step-builder';

export class DynamicConditionalActionFlowBuilder {
  private readonly steps: StepValue[] = [];

  constructor(private readonly description?: string) {}

  public addStep(
    stepBuilder:
      | SelectNextByValueStepBuilder<unknown>
      | SelectNextByActionStepBuilder,
  ): this {
    this.steps.push(stepBuilder.build());
    return this;
  }

  public build(): DynamicConditionalActionChainArgs {
    if (this.steps.length === 0) {
      throw new Error(
        `No steps have been defined for action flow with description '${
          this.description ?? 'N/A'
        }'.`,
      );
    }

    return {
      type: 'DynamicConditionalActionChainArgs',
      description: this.description,
      steps: this.steps,
    };
  }
}
